import { Fragment } from 'react'

interface TextProps {
  text: string | null | undefined
}

/**
 * Renders text with line breaks in the content.
 */
export function Text({ text }: TextProps) {
  const lines = (text || '').split('\n')
  return (
    <>
      {lines.map((line, i) =>
        i === lines.length - 1 ? (
          line
        ) : (
          <Fragment key={i}>
            {line}
            <br />
          </Fragment>
        ),
      )}
    </>
  )
}
